module.exports = __webpack_public_path__ + "static/media/zfy.6b06dd89.jpg";